const COMPLETED = "COMPLETED";

export { COMPLETED };
